<template>
	<div>
		<v-row>
			<v-col md="3" class="pt-0">
				<v-card class="d-flex flex-row " flat >
					<v-card  flat >
						<img src="@/assets/order.svg" alt="img"  width="25px" class="mt-3 mr-1">
					</v-card>
					<v-card  flat >
						<p class="filter-sub-title">{{$lang.TRIP_ID}}</p>
						<p class="sub-title-text">{{trip_id}}</p>
					</v-card>
				</v-card>
			</v-col>
			<v-col md="3" class="pt-0">
				<v-card class="d-flex flex-row  pt-0" flat >
					<v-card   flat >
						<img src="@/assets/drawer/shipment-active.svg" alt="img"  width="25px" class="mt-3 mr-1">
					</v-card>
					<v-card class="pa-2" flat >
						<p class="filter-sub-title">{{$lang.PACKAGES}}</p>
						<p class="sub-title-text">{{trip_details.shipment_count}}</p>
					</v-card>
				</v-card>
			</v-col>
			<v-col md="3" class="pt-0">
				<v-card class="d-flex flex-row pt-0" flat >
					<v-card   flat >
						<img src="@/assets/calender.svg" alt="img"  width="25px" class="mt-3 mr-1">
					</v-card>
					<v-card class="pa-2" flat >
						<p class="filter-sub-title">{{$lang.ASSIGNED_ON}}</p>
						<p class="sub-title-text">{{trip_details.created}}</p>
					</v-card>
				</v-card>
			</v-col>
			<v-col md="3" class="pt-0">
				<v-card class="d-flex flex-row pt-0" flat  v-if="trip_details.completed_on">
					<v-card class="pa-2" flat >
						<p class="filter-sub-title">{{$lang.COMPLETED_ON}}</p>
						<p class="sub-title-text">{{trip_details.completed_on}}</p>
					</v-card>
				</v-card>
			</v-col>
			<v-col md="12" class="pt-0">
				<span v-if="trip_details.trip_completed" class="trip_completed">Completed</span>
				<span v-if="!trip_details.trip_completed" class="trip_ongoing">On going</span>
			</v-col>
		</v-row>
		<v-row>
			<v-col md="3" class="pt-0">
				<p class="sub-title-text-dark">{{$lang.DELIVERY_AGENT_DETAILS}}
					<span v-if="!trip_details.trip_completed"  class="underline messge-text-green mr-2 fs-14 cursor-pointer" @click="openReassignnmentDialog">{{$lang.RE_ASSIGN}}</span>
				</p>
				<p class="sub-title-text-dark secondary-text fs-13">{{trip_details.delivery_agent_name}}</p>
				<p class="sub-title-text-dark secondary-text fs-13">{{$lang.MOBILE_PREFIX}}{{trip_details.delivery_agent_number}}</p>
			</v-col>
			<v-col md="2" class="pt-0">
				<p class="sub-title-text-dark">{{$lang.TOTAL_AMOUNT}}</p>
				<p class="sub-title-text-dark secondary-text fs-13">{{trip_details.total_amount}}</p>
			</v-col>
			<v-col md="2" class="pt-0">
				<p class="sub-title-text-dark">{{$lang.COLLECTION_AMOUNT}}</p>
				<p class="sub-title-text-dark secondary-text fs-13">{{trip_details.trip_collection_amount}}</p>
			</v-col>
			<v-col md="2" class="pt-0">
				<p class="sub-title-text-dark">{{$lang.TOTAL_RETURNS}}</p>
				<p class="sub-title-text-dark secondary-text fs-13">{{trip_details.returned_count}}</p>
			</v-col>
			<v-col md="2" class="pt-0">
				<p class="sub-title-text-dark">{{$lang.NUMBER_OF_STOPS}}</p>
				<p class="sub-title-text-dark secondary-text fs-13">{{trip_details.num_of_stops}}</p>
			</v-col>
		</v-row>

		<assign-delivery-agent-dialog :dialog="dialog" :trip_id="trip_id"
		ref="assign_delivery_agent_elm" @update-data="update"/>

	</div>
</template>
<script type="text/javascript">
export default {
	props:['trip_details','trip_id'],
	components: {
		AssignDeliveryAgentDialog :()=>import('./AssignDeliveryAgentDialog.vue'),
	},
	data(){
		return{
			dialog:{
				flag:false
			}
		}
	},
	methods:{
		openReassignnmentDialog(){
			this.dialog.flag=true
			this.$refs.assign_delivery_agent_elm.delivery_agent_id_list=[]
			this.$refs.assign_delivery_agent_elm.getDeliveryAgents()
		},
		update(delivery_agent){
			this.trip_details.delivery_agent_name=delivery_agent.agent_name
			this.trip_details.delivery_agent_number=delivery_agent.agent_phone_number

		}
	}
}
</script>